import { useEffect, useState } from 'react';
import { PAYMENT_METHOD_TYPE } from '../../../../../constants/constant';

export const useSquarePayment = () => {

    const [squareInstance, setSquareInstance] = useState(null);

    const tokenizeCard = async (card) => {
        if (!card) return { status: 'ERROR', message: 'Payment form is failed to initialized' };

        try {
            const result = await card.tokenize();
            if (result.status === 'OK') {
                return result.token;
            } else {
                return { status: 'ERROR', message: processError(result?.errors) || 'Tokenization failed' };
            }
        } catch (error) {
            return { status: 'ERROR', message: error.message };
        }
    };

    const processError = (errors) => {
        if(Array.isArray(errors)){
            return errors[0]?.message ? errors[0]?.message : 'Tokenization failed'
        }else if(typeof errors === 'string'){
            return errors
        }else{
            return JSON.stringify(errors)
        }
    }

    //initializing square sdk
    const initializeSquare = (locationID) => {
        if (!window.Square) {
            alert('Failed to initiate payment sdk');
            return;
        }

        const square = window.Square.payments(process.env.REACT_APP_SQUARE_APPLICATION_ID, locationID);
        setSquareInstance(square);
    }

    return { tokenizeCard,initializeSquare, squareInstance };
};
